import { FC } from 'react'
import { useAppSelector } from '../../hooks'
import { selectResults } from '../searchSlice'
import { useHighlightSearchResult, useSelectSearchResult } from '../hooks'
import { SearchResult } from '../types'


const ParcelSearchResults: FC = () => {
  const results = useAppSelector(selectResults)
  if (!results) return null

  return (
    <div id="search-results">
      <ul>
        {results.map((result, i) => (
          <ParcelSearchResult key={i} result={result} index={i} />
        ))}
      </ul>
    </div>
  )
}


interface ParcelSearchResultProps {
  result: SearchResult
  index: number
}

const ParcelSearchResult: FC<ParcelSearchResultProps> = ({ result, index }) => {
  const highlight = useHighlightSearchResult(result.type, result.handle)
  const select = useSelectSearchResult(result, index)
  return (
    <li onMouseEnter={() => highlight(true)} onMouseLeave={() => highlight(false)} onClick={select}>
      {result.label}
      <small>{result.type === "Address" ? "" : result.subLabel}</small>
    </li>
  )
}

export default ParcelSearchResults